/* unplugin-vue-components disabled */import { render } from "./c-title-card.vue?vue&type=template&id=3ba2153e&scoped=true"
import script from "./c-title-card.vue?vue&type=script&lang=js"
export * from "./c-title-card.vue?vue&type=script&lang=js"

import "./c-title-card.vue?vue&type=style&index=0&id=3ba2153e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba2153e"]])

export default __exports__